export default __webpack_public_path__ + "static/media/mug.0dbe7c73.jpg";